import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getTaskLocation } from '../tasksActions';
import EmtithalOfficeTasks from './EmtithalOfficeTasks';
import { getEmtithalOfficeTasks, exportEmtithalOfficeTasksReport } from './emtithalOfficeTasksActions';

const mapStateToProps = state => ({
  taskList: state.task.emtithalOfficeTasksList,
  isLoading: state.task.emtithalOfficeTasksLoading,
  totalCount: state.task.emtithalOfficeTasksCount,
  pageSize: state.task.emtithalOfficeTasksPageSize,
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  locationsList: state.task.locationsList,
  exportLoading: state.task.exportEmtithalOfficeTasksReportLoading,
});

const mapDispatchToProps = dispatch => ({
  getEmtithalOfficeTasks: params => dispatch(getEmtithalOfficeTasks(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  exportEmtithalOfficeTasksReport: params => dispatch(exportEmtithalOfficeTasksReport(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmtithalOfficeTasks);
